export const Services = (props) => {
  return (
    <div id='services' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Futómű és szerviz szolgáltatásaink</h2>
          <p>
            A futómű beállítás mellett teljes körű szolgáltatásokat nyújuk autószerviz, autó és motorgumi szerelés és értékesítés, valamint motorgumi szerelés és értékesítés körében is.
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  {' '}
                  <i className={d.icon}></i>
                  <div className='service-desc'>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'betöltés'}
        </div>
      </div>
    </div>
  )
}
